import React from "react";
import styled from "styled-components";
// import Me from "../assets/Images/maheshcenter.png";
import {Mahesh} from "../components/subComponents/AllSvgs"
import { motion } from "framer-motion";
import Typed from "react-typed"
const BOX = styled(motion.div)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  width: 65vw;
  height: 55vh;
  display: flex;

  background: linear-gradient(
        to right,
        ${(props) => props.theme.body} 50%,
        ${(props) => props.theme.text} 50%
      )
      bottom,
    linear-gradient(
        to right,
        ${(props) => props.theme.body} 50%,
        ${(props) => props.theme.text} 50%
      )
      top;
  background-repeat: no-repeat;
  background-size: 100% 2px;

  border-left: 2px solid ${(props) => props.theme.body};
  border-right: 2px solid ${(props) => props.theme.text};
  z-index: 1;
`;
const SubBox = styled.div`
  width: 50%;
  position: relative;
  dislay: flex;

  .pic {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 100%;
    height: auto;
  }
  @media (max-width: 720px) {
    .pic{
    width:215%;  
    bottom:100px;
    }
  }
`;

const Text = styled.div`
  font-size: calc(1em + 1.5vw);
  color: ${(props) => props.theme.body};
  padding: 2rem;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: space-evenlty;

  & > *:last-child {
    color: ${(props) => `rgba(${props.theme.bodyRgba},0.6)`};
    font-size: calc(0.5rem + 1.5vw);
    font-weight: 300;
  }
  @media (max-width: 720px) {
  font-size: calc(0.7em + 1.5vw);
    text-align: center;
    margin-top: 70%;
    line-height:1.5;
    padding:0rem;
  }
`;

// const introimg = keyframes`
//     0%  {background-image: ${Mahesh};
//     background-size: cover;    
//     }
    
//     50% {background-image: url("../Assets/images/tech3.jpeg");
//     background-size: cover;    
//     }
//     100% {background-image: url("../Assets/images/tech4.jpg");
//     background-size: cover;    
//     }
// `

function Intro() {
  return (
    <BOX
      initial={{ height: 0 }}
      animate={{ height: "55vh" }}
      transition={{ type: "spring", duration: 2, delay: 1 }}
    >
      <SubBox>
        <Text>
          <h1>Hi,</h1>
          <h3>I'm Mahesh Gaikwad</h3>
          <Typed
                    strings={["I'm a Full Stack Web Developer...",
                    'Write Articles on Web Technologies...',
                    'Exploring and Learning New Tech Stacks...'
                  ]}
                    typeSpeed={100}  
                    backSpeed={100}  
                    loop
                />
        </Text>
      </SubBox>
      <SubBox>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 2 }}
        >
          {/* <img className="pic" src={Me} alt="Profile" /> */}
          <Mahesh className="pic"/>
        </motion.div>
      </SubBox>
    </BOX>
  );
}

export default Intro;
